module.exports = __webpack_public_path__ + "static/stars-zoom-0b704d046ed495ddfbe1774f4336e5f2.jpg";